import { render } from "./cookies.vue?vue&type=template&id=48782204&scoped=true"
const script = {}

import "./cookies.vue?vue&type=style&index=0&id=48782204&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48782204"]])

export default __exports__